import Validation from "utils/validation.utils";
import locale from "localization";
import { CashinCardPaymentSelection } from "enums";
import { formatAmount, parseNumber } from "utils";

export const initialState = (state = {}, options = {}) => {
  const {
    dailyRemainingLimit = null,
    weeklyRemainingLimit = null,
    monthlyRemainingLimit = null,
  } = options;

  const toNullableNumber = (value) => {
    if (value == null) {
      return null;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const limits = [
    {
      remaining: toNullableNumber(dailyRemainingLimit),
      message: locale.yourRemainingDailyLimitIs,
    },
    {
      remaining: toNullableNumber(weeklyRemainingLimit),
      message: locale.yourRemainingWeeklyLimitIs,
    },
    {
      remaining: toNullableNumber(monthlyRemainingLimit),
      message: locale.yourRemainingMonthlyLimitIs,
    },
  ];

  const validateRemainingLimit = (field) => {
    const rawValue = field?.value?.toString().trim();
    if (!rawValue) {
      return { error: false, message: "" };
    }

    const amount = Number(parseNumber(field.value));
    if (!Number.isFinite(amount) || amount <= 0) {
      return { error: false, message: "" };
    }

    const validLimits = limits.filter((item) => {
      return item.remaining != null;
    });

    const lowestLimit = validLimits.reduce((lowest, current) => {
      if (!lowest || current.remaining < lowest.remaining) {
        return current;
      }
      return lowest;
    }, null);

    const exceededLimit =
      lowestLimit && amount > lowestLimit.remaining
        ? lowestLimit
        : null;

    if (!exceededLimit) {
      return { error: false, message: "" };
    }

    if (exceededLimit.remaining <= 0) {
      return {
        error: true,
        message: locale.yourCashInLimitHasBeenReached,
      };
    }

    return {
      error: true,
      message: locale.populate(exceededLimit.message, [formatAmount(exceededLimit.remaining)]),
    };
  };

  const {
    nameOnCard = {
      value: "",
      label: locale.nameOnCard,
      disabled: false,
      validations: [Validation.required(), Validation.name()],
      required: true,
      placeholder: locale.enterNameHere,
      maxLength: 75,
    },
    cardNumber = {
      value: "",
      disabled: false,
      validations: [
        Validation.required(),
        Validation.numeric({ noMessage: true }),
        Validation.minlength(16, locale.cardNumberYouEnterIsIncorrect),
      ],
      required: true,
      label: locale.cardNumber,
      placeholder: locale.enterCardNumber,
    },
    expiryDate = {
      value: "",
      name: "expiryDate",
      validations: [Validation.required(), Validation.expiryDate()],
      required: true,
      label: locale.expiryDate,
      placeholder: locale.mmYY,
      maxLength: 5,
    },
    cvv = {
      value: "",
      name: "cvv",
      validations: [
        Validation.required(),
        Validation.numeric({ noMessage: true }),
        Validation.minlength(3),
      ],
      required: true,
      label: locale.cvv,
      placeholder: locale.cvv,
      maxLength: 3,
      type: "password",
    },
    amount = {
      value: "",
      name: "amount",
      validations: [
        Validation.required(),
        Validation.min(100, {
          customMessage: locale.populate(locale.minimumCashInIsAmount, ["100.00"]),
          isFormatted: true,
        }),
        Validation.max(500000, {
          customMessage: locale.populate(locale.maximumCashInIsAmount, ["500,000.00"]),
          isFormatted: true,
        }),
        validateRemainingLimit,
      ],
      required: true,
    },
    cashInCardPaymentSelection = {
      name: "cashInCardPaymentSelection",
      value: CashinCardPaymentSelection.SavedCards,
    },
  } = state;
  return {
    nameOnCard: {
      name: "nameOnCard",
      ...nameOnCard,
    },
    cardNumber: {
      name: "cardNumber",
      ...cardNumber,
    },
    expiryDate,
    cvv,
    amount,
    cashInCardPaymentSelection,
  };
};
